import { montserratMedium, montserratNormal, montserratSemibold } from '@/assets/fonts/montserrat'
import { hero } from '@/helpers/content/id/services/bookeeping/hero'
import React from 'react'
import bgHero from "@/assets/bookeeping_page/bg-hero.svg"
import Image from 'next/image'
import ctaImage from "@/assets/ctasection/ctaimage1.png"
import image1 from "@/assets/bookeeping_page/image1.png"
import image2 from "@/assets/bookeeping_page/image2.png"
import cam from "@/assets/bookeeping_page/video-camera.svg"
import { ArrowUpIcon, ChevronDownIcon } from '@heroicons/react/24/outline'
import arrowTray from "@/assets/bookeeping_page/arrow-down-tray.svg"
import bell from "@/assets/bookeeping_page/bell.svg"
import Button from '@/components/Button/Button'
import wa from "@/assets/bookeeping_page/wa-outline-black.svg"
import { useTranslation } from 'react-i18next';

export default function HeroBookeeping({ moveToSection }) {
  const { t } = useTranslation();

  return (
    <div className="bg-gray-cool-50 flex relative pt-[10rem] md:pt-[10rem] -top-32 flex-col w-full">
      <div className='flex overflow-hidden px-4 pt-6 lg:px-8 lg:pt-0 w-full max-w-[1280px] md:justify-center md:items-center flex-col h-full lg:container lg:mx-auto relative'>
        <div className='flex w-[48rem] md:w-[68.4rem] lg:w-full absolute h-full md:bottom-0'>
          <Image src={bgHero} className='w-full h-full absolute -bottom-5 ' />
        </div>
        <div className={`w-full lg:w-1/2 leading-[44px] text-[36px] md:text-[60px] text-gray-cool-700 flex justify-center items-center lg:mx-auto text-center ${montserratSemibold.className}`}>
          <p className='flex justify-center items-center w-full leading-[40px] md:leading-[57px]'>{t(hero.title)}</p>
        </div>
        <div className={`${montserratNormal.className} text-base md:text-[20px] leading-[30px] pt-4 md:pt-6 w-full md:w-[39rem] lg:w-full max-w-[640px] tracking-wide pb-0 md:pb-7 lg:pb-9 flex md:justify-center md:items-center md:text-center md:px-3`}>{t(hero.description)}</div>
        <div className="flex md:justify-center space-x-3 md:space-x-6 py-[32px] relative z-20">
          <Button onClick={() => moveToSection("pricingRef")} className={`${montserratSemibold.className}  py-1 bg-blue-primary-500 rounded-md md:text-base text-[14px] hover:cursor-pointer hover:bg-blue-primary-600 text-base-white`}>{t('home_pricing')}</Button>
          <Button onClick={() => window.open(`https://api.whatsapp.com/send?phone=6281287889023&text=${encodeURIComponent(t('bookeeping_whatsapp_link'))}`, "_blank")} className={`bg-base-white hover:bg-gray-cool-100 border-[1px] border-gray-cool-200 rounded-md text-base-black ${montserratSemibold.className}`}>
            <div className='w-5 mr-3'>
              <Image src={wa} />
            </div>
            {t('pricing_button_text')}
          </Button>
        </div>
        <div className='flex w-full md:w-[45rem] lg:w-[70%] justify-center items-center relative bottom-0 lg:pt-0 md:pt-8 h-full'>
          <div className='w-[5rem] md:w-[11rem] lg:w-[28%] flex bg-base-white flex-col left-0 md:left-4 lg:left-0 top-0 absolute h-fit p-[5px] md:p-[9px] lg:p-[14px] border-[1px] border-gray-cool-200 rounded-[3px] md:rounded-md drop-shadow-md'>
            <div className='flex flex-col pb-[4px] md:pb-[9px] lg:pb-[14px] w-full'>
              <div className={`${montserratSemibold.className} text-[3.5px] md:text-[8px] lg:text-[11px]`}>Monthly financial reports are ready!</div>
              <div className={`${montserratNormal.className} text-[3px] md:text-[8px] lg:text-[11px]`}>Download the full report below.</div>
            </div>
            <div className="w-full flex justify-center items-center relative">
              <div className='rounded-full bg-blue-primary-500 flex justify-center items-center p-[1px] -left-3 md:-left-7 lg:-left-10 absolute'>
                <Image className='w-[10px] md:w-fit' src={bell} />
              </div>
              <div className='flex space-x-[2px] md:space-x-1 w-full justify-center p-[2px] md:p-[6px] lg:p-2 items-center rounded-[2px] bg-blue-primary-50 text-blue-primary-500'>
                <p className={`${montserratMedium.className} pt-[1.5px] md:pt-0 text-[3px] flex justify-center items-center md:text-[6px] lg:text-[11px]`}>Download All</p>
                <Image src={arrowTray} className='w-[4px] md:w-[6px] lg:w-[13px]' />
              </div>
            </div>
          </div>
          <div className='w-[5rem] md:w-[11rem] lg:w-1/4 flex bg-base-white flex-col left-0 bottom-[2rem] md:left-6 md:bottom-16 lg:left-0 lg:bottom-6 absolute h-fit p-[5px] md:p-[9px] lg:p-[14px] border-[1px] border-gray-cool-200 rounded-[3px] md:rounded-md drop-shadow-md'>
            <div className='flex pb-[5px] md:pb-[9px] lg:pb-[14px] w-full justify-between'>
              <p className={`${montserratSemibold.className} text-base-black text-[5px] md:text-[9px] lg:text-[16px]`}>Financial Reports</p>
              <div className={`${montserratSemibold.className} md:rounded-[3px] lg:rounded-md text-[3px] md:text-[9px] lg:text-[11px] text-semantic-negative-600 bg-semantic-negative-50 px-[2px] items-center flex`}>
                New
              </div>
            </div>
            <div>
              <Image src={image2} className='w-fit' />
            </div>
          </div>
          <div className='w-[48%] md:w-[40%] lg:w-[45%] flex justify-center items-center h-full'>
            <Image src={ctaImage} className="w-full transform -scale-x-100" />
          </div>
          <div className='w-[5rem] md:w-[12rem] lg:w-[13rem] flex bg-base-white flex-col right-0 md:right-4 lg:right-0 top-0 absolute h-fit p-[5px] md:p-[9px] lg:p-[14px] border-[1px] border-gray-cool-200 rounded-md drop-shadow-md'>
            <div className='flex w-full justify-between'>
              <p className={`${montserratNormal.className} text-base-black text-[3px] md:text-[8px] lg:text-[11px]`}>Net Profit</p>
              <div className='px-[3px] md:px-1 rounded-[3px] md:rounded-full border-[0.5px] md:border-[1px] text-semantic-positive-600 border-semantic-positive-600 bg-semantic-positive-50 items-center flex'>
                <ArrowUpIcon className='w-[3px] md:w-[6px] lg:w-2' />
                <p className='text-[3px] pt-[1px] px-[1px] md:pt-0 md:px-0 md:text-[6px] lg:text-[8px]'>30%</p>
              </div>
            </div>
            <p className={`${montserratSemibold.className} pb-[16px] pt-1 border-b border-gray-cool-200 text-[5px] md:text-sm lg:text-[17px]`}>Rp 83,000,000.00</p>
            <div className='flex w-full justify-between items-center'>
              <p className={`${montserratNormal.className} text-[5px] md:text-[6px] lg:text-sm`}>Details</p>
              <div className='text-blue-primary-500 space-x-1 py-2 flex'>
                <p className={`${montserratNormal.className} md:text-[6px] lg:text-sm text-[5px]`}>View less</p>
                <ChevronDownIcon className='w-[3px] md:w-[6px] lg:w-3 rotate-180' />
              </div>
            </div>
            <div>
              <Image src={image1} className='w-fit' />
            </div>
          </div>
          <div className='w-1/4 hidden lg:flex bg-blue-primary-50 text-blue-primary-500 flex-col right-0 bottom-14 absolute h-fit p-[14px] border-[1px] border-gray-cool-200 rounded-md drop-shadow-md'>
            <div className='flex pb-1 w-full'>
              <Image src={cam} />
              <div className={`${montserratSemibold.className} px-2 text-[18px]`}>{t("bookeeping_hero_image_consultation")}</div>
            </div>
            <div className={`${montserratNormal.className} text-blue-primary-500 text-[14px]`}>{t("bookeeping_hero_image_anytime")}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
